import React, { useId, useRef, useState } from 'react';
import { StyledControlPanel, StyledCarousel, StyledSlideContainer } from './index.styles.js';
import {} from '../headline/index.js';
import { IconButton } from '../icon-button/index.js';
import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-alpha-common';
import {} from '../text-link/index.js';
import { Slide } from './slide.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { useCarouselKeyboardNavigation } from './useCarouselKeyboardNavigation.js';
const isScrollPositionEnd = (container) => {
    if (!container)
        return;
    return container.scrollLeft + container.offsetWidth >= container.scrollWidth;
};
const scrollSlideClick = (type, container, slideWidth) => {
    if (!container || !slideWidth) {
        return;
    }
    const root = document.documentElement;
    const pageMargin = parseInt(getComputedStyle(root).getPropertyValue('--page-margin'));
    const marginRight = parseInt(SYS_SPACE_FIXED_200);
    let moddedSlideWidth = slideWidth;
    if (type === 'next') {
        if (container.scrollLeft === 0) {
            moddedSlideWidth = slideWidth + pageMargin;
        }
        else {
            moddedSlideWidth = slideWidth + marginRight;
        }
        return container.scrollBy({
            left: moddedSlideWidth,
            behavior: 'smooth'
        });
    }
    if (isScrollPositionEnd(container)) {
        moddedSlideWidth = slideWidth + pageMargin;
    }
    else {
        moddedSlideWidth = slideWidth + marginRight;
    }
    return container.scrollBy({
        left: slideWidth && moddedSlideWidth * -1,
        behavior: 'smooth'
    });
};
// Refactor: We can probably just hardcode the width and get rid of the slideWidth state
export const Carousel = ({ items, margin, ariaCarouselLabel, ariaLiveRegionText, ariaSlideLabel, ariaControlsLabel, aspectRatio = '1:1', ariaSlideRoleDescription, layout = 'flexible', className, incrementElement, decrementElement, ...rest }) => {
    const id = useId();
    const totalItems = items.length;
    const containerRef = useRef(null);
    const [visibleIndices, setVisibleIndices] = useState([]);
    const [slideWidth, setSlideWidth] = useState();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    useCarouselKeyboardNavigation({
        containerRef,
        slideWidth,
        onMove: (nextIndex) => setActiveTabIndex(nextIndex)
    });
    const getCurrentlyVisibleSlides = (index, visible) => {
        const shiftedIndex = index + 1;
        setVisibleIndices((prev) => {
            if (visible) {
                return prev.includes(shiftedIndex)
                    ? prev
                    : [...prev, shiftedIndex].sort((a, b) => a - b);
            }
            else {
                return prev.filter((i) => i !== shiftedIndex);
            }
        });
    };
    return (React.createElement(StyledCarousel, { margin: margin, role: "region", "aria-label": ariaCarouselLabel, id: id, className: className, ...pickDataProps(rest) },
        ariaLiveRegionText && (React.createElement("div", { "aria-live": "polite", style: { position: 'absolute', left: '-9999px' } }, ariaLiveRegionText(visibleIndices))),
        React.createElement(StyledSlideContainer, { ref: containerRef, tabIndex: -1, onFocus: (e) => {
                if (e.currentTarget !== e.target)
                    return;
                const active = containerRef.current?.querySelectorAll('li')[activeTabIndex];
                active?.focus({ preventScroll: true });
            } }, items.map((item, index) => (React.createElement(Slide, { key: index, aspectRatio: aspectRatio, layout: layout, ariaSlideLabel: ariaSlideLabel, ariaSlideRoleDescription: ariaSlideRoleDescription, totalItems: totalItems, index: index, item: item, isActive: index === activeTabIndex, 
            // All slides have the same width per css. So we only need one width, not an array.
            onWidthChange: (width) => setSlideWidth(width), onVisibilityChange: getCurrentlyVisibleSlides })))),
        React.createElement(StyledControlPanel, { "aria-controls": id, role: "group", "aria-label": ariaControlsLabel },
            React.createElement(IconButton, { variant: "primary", size: "md", icon: "back", "aria-label": decrementElement['aria-label'], disabled: containerRef.current?.scrollLeft === 0, onClick: () => {
                    scrollSlideClick('prev', containerRef.current, slideWidth);
                    const nextIndex = Math.max(0, activeTabIndex - 1);
                    setActiveTabIndex(nextIndex);
                } }),
            React.createElement(IconButton, { variant: "primary", size: "md", icon: "forward", "aria-label": incrementElement['aria-label'], onClick: () => {
                    scrollSlideClick('next', containerRef.current, slideWidth);
                    const nextIndex = Math.min(items.length - 1, activeTabIndex + 1);
                    setActiveTabIndex(nextIndex);
                }, disabled: isScrollPositionEnd(containerRef.current) }))));
};
Carousel.displayName = 'Carousel';
//# sourceMappingURL=index.js.map